<template>
    <div class="iframeGamesList">
        <div class="iframeGamesList__left">
            <main-menu></main-menu>
        </div>
        <div class="iframeGamesList__right">
            <div>
                <div class="title-container">
                    <h3 class="grm-title">1. Choose a project</h3>
                    <h3 class="grm-title">2. Choose environment</h3>
                </div>
                <select class="form__select" v-model="chosenProject">
                    <option :key="proj.value" :value="proj.value" v-for="proj in projects">
                        {{ proj.name }}
                    </option>
                </select>
                <select class="form__select" v-model="chosenEnv">
                    <option :key="env.value" :value="env.value" v-for="env in envs">
                        {{ env.name }}
                    </option>
                </select>
                <PickGamesList :pickedGames="iframeGames" :allGames="allGames" :onSave="onSave" />
            </div>

            <InfoModal
                v-if="isIframeListEdited"
                :msg="'Iframe games list was successfully edited.'"
                :onCloseModal="closeInfoModal"
            ></InfoModal>
        </div>
    </div>
</template>

<script>
import MainMenu from '../MainMenu/MainMenu.vue';
import { projects } from '../../constants/projects';
import {
    iframeAarpEnvironmentsProd,
    iframeAarpEnvironmentsDev,
    iframeArenaEnvironmentsProd,
    iframeArenaEnvironmentsDev,
    iframeArkcomEnvironmentsProd,
    iframeArkcomEnvironmentsDev,
} from '../../constants/iframeEnvironmentNames';
import config from '../../config';

import { ClearCacheService } from '../../services/ClearCacheService';
import InfoModal from '../InfoModal/InfoModal.vue';
import CloseIcon from '../CloseIcon/CloseIcon.vue';
import AddIcon from '../AddIcon/AddIcon.vue';
import PickGamesList from '../PickGamesList/PickGamesList.vue';
export default {
    name: 'IframeGamesList',
    components: { MainMenu, CloseIcon, AddIcon, InfoModal, PickGamesList },
    data() {
        return {
            chosenProject: null,
            chosenEnv: null,
            envs: null,
            projects,
            arenaEnvironments:
                (process.env.NODE_ENV === 'live' || process.env.NODE_ENV === 'feature-live') ? iframeArenaEnvironmentsProd : iframeArenaEnvironmentsDev,
            arkcomEnvironments:
                (process.env.NODE_ENV === 'live' || process.env.NODE_ENV === 'feature-live') ? iframeArkcomEnvironmentsProd : iframeArkcomEnvironmentsDev,
            aarpEnvironments:
                (process.env.NODE_ENV === 'live' || process.env.NODE_ENV === 'feature-live') ? iframeAarpEnvironmentsProd : iframeAarpEnvironmentsDev,
            allGames: [],
            iframeGames: [],
            isIframeListEdited: false,
            editIframeListError: null,
        };
    },
    methods: {
        getAllGames: function () {
            return this.$gameApi.get(`/games`).then(games => games.map(game => game.slug));
        },
        getIframeGames: function () {
            return this.$http
                .get(`${config.apiUrl}/iframe-games-list?project=${this.chosenProject}&env=${this.chosenEnv}`)
                .then(
                    (response) => response.body,
                    (error) => {
                        console.error(error);
                    }
                );
        },
        onSave: function (gamesToSave) {
            return this.$http
                .post(
                    `${config.apiUrl}/iframe-games-list?project=${this.chosenProject}&env=${this.chosenEnv}`,
                    gamesToSave
                )
                .then(
                    () => {
                        this.isIframeListEdited = true;
                        this.clearCache();
                    },
                    (error) => {
                        this.editIframeListError = error.body.Message ?? 'failed to save iframe games list';
                        console.error(error);
                    }
                );
        },
        closeInfoModal: function () {
            this.isIframeListEdited = false;
        },
        getIframePath: function () {
            let sharedContentFolder = '_arena-shared-content_';
            let folder = '';

            switch (this.chosenProject) {
                case 'arena51':
                    if (this.chosenEnv == 'canary') {
                        folder = 'ark-iframe-games-canary';
                    } else if (this.chosenEnv == 'dev' || this.chosenEnv == 'prod') {
                        folder = 'ark-iframe-games';
                    }
                    break;
                case 'arkcom':
                    folder = 'arkcom-iframe-games';
                    break;
                default:
                    break;
            }
            let containerName = this.chosenEnv === 'dev' ? 'arenaxstoragedev-blob' : 'arenaxstorage-blob';
            let path = `https://arenacloud.cdn.arkadiumhosted.com/${containerName}/arenax-index/${sharedContentFolder}/${folder}/iframe-games-list.json`;
            return path;
        },
        clearCache: function () {
            const fileUrl = this.getIframePath();
            ClearCacheService.clearCacheByItems([fileUrl], 'Url', 'Delete')
                .then((res) => {
                    if (res.ok) {
                        console.debug('cache cleared successfully');
                        return;
                    }
                    console.error('cache clear error', res);
                })
                .catch((err) => console.error('cache clear request error', err));
        },
    },
    watch: {
        chosenProject: {
            handler(newValue) {
                switch (newValue) {
                    case 'arkcom':
                        this.envs = this.arkcomEnvironments;
                        break;
                    case 'arena51':
                        this.envs = this.arenaEnvironments;
                        break;
                    case 'aarp':
                        this.envs = this.aarpEnvironments;
                        break;
                    default:
                        break;
                }
                this.chosenEnv = null;
            },
        },
        chosenEnv: {
            handler(newValue) {
                if (!newValue) {
                    return;
                }
                const requests = !this.allGames.length
                    ? [this.getIframeGames, this.getAllGames]
                    : [this.getIframeGames];
                // this.isGamesLoadInProgress = true;
                Promise.all(requests.map((r) => r())).then(([iframeGames, allGames]) => {
                    if (allGames) {
                        this.allGames = allGames;
                    }
                    this.iframeGames = iframeGames;
                    this.iframeSearch = null;
                    this.allGamesSearch = null;
                    // this.isGamesLoadInProgress = false;
                });
            },
        },
        iframeGames: {
            handler(newIframeGames) {
                this.filteredIframeGames = newIframeGames;
                this.filteredAllGames = this.allGames.filter((g) => !newIframeGames.includes(g));
            },
        },
        iframeSearch: {
            handler(newValue) {
                if (!newValue) {
                    this.searchedIframeGames = this.filteredIframeGames;
                }
                this.searchedIframeGames = this.filteredIframeGames.filter((g) => g.includes(newValue));
            },
        },
        allGamesSearch: {
            handler(newValue) {
                if (!newValue) {
                    this.searchedAllGames = this.filteredAllGames;
                }
                this.searchedAllGames = this.filteredAllGames.filter((g) => g.includes(newValue));
            },
        },
    },
};
</script>

<style scoped src="./iframeGamesList.scss" lang="scss"></style>
